import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { focusOnlyRole, getUserType } from '../Utils/adminUserTypes';
import { zavvyActiveForUser } from '../Components/FocusMode/Zavvy/role';

/** Old Pro review pages whose job Focus Mode's task deck now does. */
const REVIEW_VIEWS = /^(MyReview|PolicyReview|TrainingReview|HardwareReview)/;

/** Where a Focus-only role lands for a given /adminlist?view= value. */
export function focusTargetFor(search) {
  const view = new URLSearchParams(search || '').get('view') || '';
  return REVIEW_VIEWS.test(view) ? '/view/focus?view=tasks' : '/view/focus';
}

/**
 * When the new Zavvy chat is on, members, guests, vendors and regulators stay in Focus Mode.
 * Any /adminlist URL they reach is replaced with the Focus chat, and the old review pages
 * map to the task deck. When the organisation has Zavvy off, those roles keep the classic
 * Pro review pages.
 */
export default function FocusOnlyGuard({ role = getUserType(), children }) {
  const { search } = useLocation();
  if (focusOnlyRole(role) && zavvyActiveForUser()) return <Navigate to={focusTargetFor(search)} replace />;
  return children;
}
